// 画像のコンテキスト読み込み（Viteでは不要だが互換性のため残す）
// require.context('../images/', true) の代替
// Viteでは public/ フォルダまたは assets として扱う

import { communityComponents } from '@/components/mountable/registry';
import { mountReactComponents } from '@/utils/react_mount';

// メインJavaScript
import '@/javascripts/main';

// オートリサイズテキストエリア
import '@/javascripts/auto_resize_textarea';

// ERB の react_component ヘルパーが出力した [data-react-component] をマウントする。
// module スクリプトは defer 実行のため、head 読み込みでも DOM は構築済み。
mountReactComponents(communityComponents);

// AJAX で挿入された部分木（erb 等）から呼び出せるようグローバルに公開する。
if (!window.Coorum) window.Coorum = {};
window.Coorum.mountReactComponents = (el?: HTMLElement) =>
  mountReactComponents(communityComponents, el ?? document);
